module.exports = __webpack_public_path__ + "static/media/StageRC.2e8aadbf.jpg";